import { type ReactNode, useEffect, useRef, useState } from "react";
import { useMe } from "../hooks/useMe";
import { useSystemConfig } from "../hooks/useSystemConfig";
import { AppsMenu } from "./AppsMenu";
import { Header } from "./Header";
import "./Layout.scss";

interface Props {
  children: ReactNode;
}

export const Layout = ({ children }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const me = useMe();
  const { loadConfig } = useSystemConfig();
  const hasLoadedInitialConfig = useRef(false);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  useEffect(() => {
    const defaultOrganization = me?.organizations?.[0];

    if (defaultOrganization && !hasLoadedInitialConfig.current) {
      // Start the session with the user's default organization config.
      // Views that operate on a specific organization can load and replace it.
      loadConfig(defaultOrganization);
      hasLoadedInitialConfig.current = true;
    }
  }, [loadConfig, me?.organizations]);

  return (
    <div className="layout-main">
      <div className="layout-vertical">
        <div className="layout-header grey">
          <Header collapsed={isCollapsed} onChange={toggleCollapse} />
        </div>
        <div className="layout-horizontal layout-lower">
          <div className="layout-lateral">
            <AppsMenu collapsed={isCollapsed} />
          </div>
          <div className="layout-content">{children}</div>
        </div>
      </div>
    </div>
  );
};
